// 文档: https://cloud.tencent.com/document/product/266/9239

import React, { Component, createRef } from 'react';
import { Button, Row, Col, Progress, Divider, message } from 'antd';
import TcVod from 'vod-js-sdk-v6';
import { post } from 'axios';
import S from './tcupload.module.less';

const rowSty = {
  marginBottom: 15,
}

const hideInput = {
  display: 'none'
}

const previewSty = {
  display: 'block',
  marginTop: 5,
  maxWidth: 200,
  height: 'auto',
}

class TcUpload extends Component {
  static defaultProps = {
    onSubmit: () => {},
  }

  state = {
    coverFile: null,
    videoFile: null,

    coverObjUrl: '',
    videoObjUrl: '',

    videoProgress: 0,
    coverProgress: 0,
    uploading: false,

    uploadInfo: null,
  }

  coverRef = createRef();
  pickCover = () => {
    this.coverRef.current.click();
  }
  
  selectCover = (e) => {
    const file = e.target.files[0];
    if ((file instanceof File) === false) {
      message.info('未选择文件!');
      return;
    }
    this.setState({
      coverFile: file,
      coverObjUrl: URL.createObjectURL(file)
    })
  }

  videoRef = createRef();
  pickVideo = () => {
    this.videoRef.current.click();
  }

  // 选择视频
  selectVideo = (e) => {
    const file = e.target.files[0];
    if ((file instanceof File) === false) {
      message.info('未选择文件!');
      return;
    }

    this.setState({
      videoFile: file,
      videoObjUrl: URL.createObjectURL(file)
    })
  }

  upload = async () => {
    const {
      coverFile,
      videoFile
    } = this.state;

    if (videoFile === null) {
      message.error('视频未选!');
      return;
    }

    try {
      this.setState({
        uploading: true,
      })
      const tcVod = new TcVod({
        getSignature: this.getSignature,
      });
      const uploader = tcVod.upload({
        mediaFile: videoFile,
        coverFile: coverFile,
      });

      // 视频上传进度
      uploader.on('media_progress', (info) => {
        this.setState({
          videoProgress: info.percent
        })
      });
      // 封面上传进度
      uploader.on('cover_progress', (info) => {
        this.setState({
          coverProgress: info.percent
        })
      })

      const res = await uploader.done();
      this.setState({
        uploadInfo: res,
        uploading: false,
      });

      this.props.onSubmit({
        ...res,
      });
    } catch (err) {
      this.setState({
        uploading: false,
      });
      message.error('上传失败, 请重试!');
      throw err;
    }
  }

  // 对上传进度四舍五入
  fixedProgress = (x) => {
    return Math.round(x * 100);
  }

  render() {
    const {
      coverFile,
      videoFile,
      uploading,
      uploadInfo,
      coverObjUrl,
      videoObjUrl,
      videoProgress,
      coverProgress,
    } = this.state;

    return (
      <div className={S.shadow}>
        {
          uploading
          && <>
              {
                coverFile !== null && 
                <>
                  <span style={{ display: 'block', marginBottom: 10 }}>封面上传进度:</span>
                  <Progress type="circle" percent={this.fixedProgress(coverProgress)} />
                  <Divider type='horizontal' style={{ margin: '15px 0' }} />
                </>
              } 
              <span style={{ display: 'block', marginBottom: 10 }}>视频上传进度:</span>
              <Progress type="circle" percent={this.fixedProgress(videoProgress)} />
             </>
        }

        {
          uploadInfo !== null && this.showPreview()
        }

        {
          uploadInfo === null && uploading === false
          && <>
              <Row style={rowSty}>
                <Col span={10}>
                  <Button onClick={this.pickCover}>添加封面</Button>
                  <input
                    type='file'
                    accept='image/*'
                    style={hideInput}
                    ref={this.coverRef}
                    onChange={this.selectCover}
                  />
                  <img src={coverObjUrl} alt='' style={previewSty} />
                </Col>
              </Row>

              <Row style={rowSty}>
                <Col span={3}>
                  <Button onClick={this.pickVideo}>添加视频 (必须)</Button>
                  <input
                    type='file'
                    accept='video/*'
                    style={hideInput}
                    ref={this.videoRef}
                    onChange={this.selectVideo}
                  />
                  {
                    videoFile !== null
                    && <video
                      autoPlay
                      controls
                      src={videoObjUrl}
                      style={previewSty}
                    />
                  }
                </Col>

              </Row>
              <Row style={rowSty}>
                <Col span={10}>
                  <Button onClick={this.upload}>开始上传</Button>
                </Col>
              </Row>
            </>
        }
      </div>
    );
  }

  showPreview = () => {
    const { uploadInfo } = this.state;
    if (uploadInfo === null) return null;

    return (
      <>
        {
          uploadInfo.cover &&
          <>
            <span style={{ display: 'block', marginBottom: 10 }}>封面:</span>
            <img style={previewSty} src={uploadInfo.cover.url} alt='' />
            <Divider type='horizontal' style={{ margin: '15px 0' }} />
          </>
        }

        <span style={{ display: 'block', marginBottom: 10 }}>视频:</span>
        <video controls autoPlay src={uploadInfo.video.url} style={previewSty} />
      </>
    );
  }

  // 获取上传签名
  getSignature = () => {
    return post('file/get-upload-signature', {
      type: 1,
    }).then(function (response) {
      return response.data.data.signature;
    })
  }
}

export default TcUpload;
